import React from 'react';
import { Listbox } from '@headlessui/react';
import { ChevronUpDownIcon } from '@heroicons/react/24/solid';
import { statusOptions } from '../../utils';

// Helper function to combine class names
function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

function StatusSelector({ selectedStatus, handleStatusChange, updatingStatus, statusError }) {
  return (
    <div>
      <Listbox value={selectedStatus} onChange={handleStatusChange}>
        <div className="relative max-w-xs">
          <Listbox.Button 
            className={classNames(
              "grid w-full cursor-default grid-cols-1 rounded-md bg-white py-1.5 pr-2 pl-3 text-left text-gray-900 outline-1 -outline-offset-1 outline-gray-300 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6 border border-gray-300",
              updatingStatus ? "opacity-50 cursor-not-allowed" : ""
            )}
            disabled={updatingStatus}
          >
            <span className="col-start-1 row-start-1 flex items-center gap-3 pr-6">
              <span
                className={classNames(
                  selectedStatus.color,
                  'inline-block px-2 py-0.5 text-xs font-semibold rounded-full'
                )}
              >
                {selectedStatus.name}
              </span>
              {updatingStatus && (
                <span className="ml-2 animate-pulse">Updating...</span>
              )}
            </span>
            <ChevronUpDownIcon
              aria-hidden="true"
              className="col-start-1 row-start-1 size-5 self-center justify-self-end text-gray-500 sm:size-4"
            />
          </Listbox.Button>

          <Listbox.Options
            className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-hidden data-leave:transition data-leave:duration-100 data-leave:ease-in data-closed:data-leave:opacity-0 sm:text-sm"
          >
            {statusOptions.map((status) => (
              <Listbox.Option
                key={status.id}
                value={status}
                className="group relative cursor-default py-2 pr-9 pl-3 text-gray-900 select-none data-focus:bg-indigo-600 data-focus:text-white data-focus:outline-hidden"
              >
                <div className="flex items-center">
                  <span
                    className={classNames(
                      status.color,
                      'inline-block px-2 py-0.5 text-xs font-semibold rounded-full'
                    )}
                  >
                    {status.name}
                  </span>
                </div>
              </Listbox.Option>
            ))}
          </Listbox.Options>
        </div>
      </Listbox>
      {statusError && (
        <p className="mt-2 text-xs text-red-500">
          {statusError}
        </p>
      )}
    </div>
  );
}

export default StatusSelector;